import { createContext, useContext, useMemo, useState } from "react";

export const VehicleDetailsContext = createContext({
  vehicleDetails: {},
  setVehicleDetails: () => {},
});

export function VehicleDetailsProvider({ children }) {
  const [vehicleDetails, setVehicleDetails] = useState({});

  const value = useMemo(
    () => ({ vehicleDetails, setVehicleDetails }),
    [vehicleDetails],
  );

  return (
    <VehicleDetailsContext.Provider value={value}>
      {children}
    </VehicleDetailsContext.Provider>
  );
}

export function useVehicleDetailsContext() {
  return useContext(VehicleDetailsContext);
}
